import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {FeatureUnitFormComponent} from '@catmodules/models/feature-units/components/feature-unit-form/feature-unit-form.component';
import {FeatureUnitsService} from '@catmodules/models/feature-units/services/feature-units.service';
import {UIBaseModule} from '@catui/ui-base.module';
import {UIFormModule} from '@catuiform/ui-form.module';
import {NetworkInterfacesModule} from "@catmodules/models/network-interfaces/network-interfaces.module";

const publicComponents = [
  FeatureUnitFormComponent,
];

const imports = [
  CommonModule,
  ReactiveFormsModule,
  UIBaseModule,
  UIFormModule,
  NetworkInterfacesModule
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [FeatureUnitsService];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class FeatureUnitsModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/feature-units/feature-units.module.ts